<template v-if="broadcast">
  <v-container pa-3 pb-5>
    <div style="display: flex; flex-direction: column; gap: 8px; padding: 12px">
      <div
        style="
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
        "
      >
        <Typography h5 bold :label="$t('Broadcast Name')" />
        <div v-if="broadcastType == 'draft'" @click="$emit('showEditNameModal')">
          <img
            src="/static/img/TooltipEdit.png"
            alt
            class="responsive-img pointer"
            style="height: 22px"
          />
        </div>
      </div>
      <Typography h5 medium color="darkGray" :label="name" />
    </div>
    <v-divider></v-divider>
    <div style="display: flex; flex-direction: column; gap: 8px; padding: 12px">
      <Typography h5 bold :label="$t('Message Type')" />
      <Typography
        v-if="sendtype == 'subscription'"
        h5
        medium
        color="darkGray"
        :label="$t('Subscription')"
      />
      <Typography
        v-else-if="sendtype == 'promotion'"
        h5
        medium
        color="darkGray"
        :label="$t('Promotional Message (within 24 hours)')"
      />
      <Typography
        v-else-if="sendtype == 'ACCOUNT_UPDATE'"
        h5
        medium
        color="darkGray"
        :label="$t('Account Update')"
      />
      <Typography
        v-else-if="sendtype == 'CONFIRMED_EVENT_UPDATE'"
        h5
        medium
        color="darkGray"
        :label="$t('Confirmed Event Update')"
      />
      <Typography
        v-else-if="sendtype == 'POST_PURCHASE_UPDATE'"
        h5
        medium
        color="darkGray"
        :label="$t('Post-Purchase Update')"
      />
      <Typography v-else h5 medium color="darkGray" :label="$t(sendtype)" />
    </div>
    <v-divider></v-divider>
    <div style="display: flex; flex-direction: column; gap: 8px; padding: 12px">
      <Typography h5 bold :label="$t('Notification Setting')" />
      <Typography
        v-if="pushtype == 'REGULAR'"
        h5
        medium
        color="darkGray"
        :label="$t('Regular Push')"
      />
      <Typography
        v-else-if="pushtype == 'SILENT_PUSH'"
        h5
        medium
        color="darkGray"
        :label="$t('Silent Push')"
      />
      <Typography
        v-else-if="pushtype == 'NO_PUSH'"
        h5
        medium
        color="darkGray"
        :label="$t('No Push')"
      />
    </div>
    <v-divider></v-divider>
    <div style="display: flex; flex-direction: column; gap: 8px; padding: 12px">
      <div
        style="
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
        "
      >
        <Typography h5 bold :label="$t('Target')" />
        <div v-if="broadcastType == 'draft'" @click="$emit('showEditTarget')">
          <img
            src="/static/img/TooltipEdit.png"
            alt
            class="responsive-img pointer"
            style="height: 22px"
          />
        </div>
      </div>
      <div>
        <Typography v-if="groupType == ''" h5 medium color="darkGray" :label="$t('All')" />
        <Typography
          v-else-if="groupType == 'facebook'"
          h5
          medium
          color="darkGray"
          :label="$t('Facebook')"
        />
        <Typography
          v-else-if="groupType == 'line'"
          h5
          medium
          color="darkGray"
          :label="$t('Line')"
        />
        <template v-else-if="groupType == 'customize'">
          <Typography h5 medium color="darkGray" :label="$t('Customize')" />
          <div class="mt-3" style="border: 1px solid #eee; border-radius: 10px">
            <div class="row py-4 px-1 ma-0">
              <div class="col s12 pb-2">
                <div style="display: flex; flex-direction: row; gap: 10px">
                  <Typography h5 bold :label="$t('broadcast member info')" />
                </div>
              </div>
              <div class="col s12 pb-2">
                <div style="display: flex; flex-direction: row; gap: 10px">
                  <Typography h5 bold :label="$t('broadcast email')" />
                  <Typography
                    h5
                    medium
                    color="darkGray"
                    :label="filter.email ? filter.email : '-'"
                  />
                </div>
              </div>
              <div class="col s12 pb-2">
                <div style="display: flex; flex-direction: row; gap: 10px">
                  <Typography h5 bold :label="$t('broadcast tel')" />
                  <Typography
                    h5
                    medium
                    color="darkGray"
                    :label="filter.phoneno ? filter.phoneno : '-'"
                  />
                </div>
              </div>
              <div class="col s12 pb-2">
                <div style="display: flex; flex-direction: row; gap: 10px">
                  <Typography h5 bold :label="$t('broadcast member type')" />
                  <Typography
                    h5
                    medium
                    color="darkGray"
                    :label="filter.membertype ? filter.membertype : '-'"
                  />
                </div>
              </div>
              <div class="col s12 pb-2">
                <div style="display: flex; flex-direction: row; gap: 10px">
                  <Typography h5 bold :label="$t('broadcast project')" />
                  <Typography
                    h5
                    medium
                    color="darkGray"
                    :label="filter.projectname ? filter.projectname : '-'"
                  />
                </div>
              </div>
              <div class="col s12 pb-2">
                <div style="display: flex; flex-direction: row; gap: 10px">
                  <Typography h5 bold :label="$t('broadcast project type')" />
                  <Typography
                    h5
                    medium
                    color="darkGray"
                    :label="filter.projecttype ? filter.projecttype : '-'"
                  />
                </div>
              </div>
              <!-- <div class="col s6 pb-2">
                <div style="display: flex; flex-direction: row; gap: 10px">
                  <Typography h5 bold :label="$t('broadcast status info')" />
                  <Typography
                    h5
                    medium
                    color="darkGray"
                    :label="filter.memberstatus ? filter.memberstatus : '-'"
                  />
                </div>
              </div> -->
              <div class="col s6 pb-2">
                <div style="display: flex; flex-direction: row; gap: 10px">
                  <Typography h5 bold :label="$t('broadcast dp type')" />
                  <Typography
                    h5
                    medium
                    color="darkGray"
                    :label="filter.dpType ? filter.dpType : '-'"
                  />
                </div>
              </div>
              <div class="col s12 mb-3"></div>
              <div class="col s12 pb-2">
                <div style="display: flex; flex-direction: column; gap: 10px">
                  <Typography h5 bold :label="$t('broadcast label')" />
                  <div
                    v-if="filter.tags != undefined && filter.tags.split(',').length >= 0"
                    style="display: flex; flex-direction: row; gap: 5px; flex-wrap: wrap"
                  >
                    <div
                      v-for="(tag, tindex) in filter.tags.split(',')"
                      :key="`tags_${tindex}`"
                      style="
                        background-color: #e6f0fb;
                        border: 1px solid #0c2f53;
                        border-radius: 6px;
                        padding: 0px 6px;
                      "
                    >
                      <Typography h5 :label="tag" />
                    </div>
                  </div>
                  <Typography v-else h5 medium color="darkGray" label="-" />
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>

    <v-divider></v-divider>
    <div style="display: flex; flex-direction: column; gap: 8px; padding: 12px">
      <div
        style="
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
        "
      >
        <Typography h5 bold :label="$t('Add tag for this broadcast')" />
        <div v-if="broadcastType == 'draft'" @click="$emit('showEditTags')">
          <img
            src="/static/img/TooltipEdit.png"
            alt
            class="responsive-img pointer"
            style="height: 22px"
          />
        </div>
      </div>
      <v-premium-lock :inline="true"></v-premium-lock>
      <Typography v-if="update_tags.length == 0" h5 medium color="darkGray" :label="$t('No tag')" />
      <template v-else>
        <div style="display: flex; flex-direction: row; gap: 5px; flex-wrap: wrap">
          <div
            v-for="(tag, tindex) in update_tags"
            :key="`tags_${tindex}`"
            style="
              background-color: #e6f0fb;
              border: 1px solid #0c2f53;
              border-radius: 6px;
              padding: 0px 6px;
            "
          >
            <Typography h5 :label="tag" />
          </div>
        </div>
      </template>
    </div>
    <v-divider></v-divider>
    <div style="display: flex; flex-direction: column; gap: 8px; padding: 12px">
      <div
        style="
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
        "
      >
        <Typography h5 bold :label="$t('Schedule Broadcast')" />
        <div v-if="broadcastType == 'draft'" @click="$emit('showEditTimeSchedule')">
          <img
            src="/static/img/TooltipEdit.png"
            alt
            class="responsive-img pointer"
            style="height: 22px"
          />
        </div>
      </div>
      <Typography
        v-if="broadcast.isschedule"
        h5
        medium
        color="darkGray"
        :label="broadcast.scheduletime | dateFormat('DD/MM/YY HH:mm ')"
      />
      <Typography v-else h5 medium color="darkGray" label="-" />
    </div>
    <v-divider></v-divider>
    <slot name="modal"></slot>
  </v-container>
</template>


<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import config from '@/config'
import GenericViewer from '@/components/elements/GenericViewer'
import MessageViewer from '@/components/elements/MessageViewer'
import Typography from '@/components/elements/Typography.vue'
import api from '@/api'
import EditModal from './EditModal'

export default {
  props: ['value', 'broadcastType'],
  data: function () {
    return {
      broadcast: undefined,
      update_status: '',
      update_tags: [],
      isSave: false,
      isFail: false,
      name: '',
      localeOptions: config.locale,
      intents: [],
      type: 'text',
      groupType: '',
      sendtype: 'subscription',
      pushtype: 'regular',
      message: '',
      quick_reply: '',
      typeOptions: [
        {
          value: 'text',
          name: 'Text',
        },
        {
          value: 'template',
          name: 'Generic',
        },
      ],
      generics: [
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: true,
        },
      ],
      messages: [],
      filter: {
        fullname: '',
        gender: 'all',
        locale: null,
        app: 'all',
        intent: null,
        email: '',
        phoneno: '',
        messagesent: {
          value: null,
          symbol: '',
        },
        timezone: {
          from: -12,
          to: 14,
        },
        activeDate: {
          enable: false,
          start: '',
          end: '',
        },
        registerDate: {
          enable: false,
          start: null,
          end: null,
        },
      },
    }
  },
  components: {
    GenericViewer,
    MessageViewer,
    Typography,
    EditModal,
  },
  mounted: function () {
    var vm = this
    vm.reset()
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
    }),
  },
  methods: {
    reset: function () {
      var vm = this
      if (vm.value) {
        vm.broadcast = Object.assign({}, vm.value)
        vm.cached_broadcast = Object.assign({}, vm.value)
      }
      if (vm.broadcast) {
        var filters = vm.broadcast.m_condition.split('&')
        filters = filters.filter((el) => {
          return el != null && el != ''
        })

        if (filters.length > 0) {
          var f = filters.map(function (filter, index) {
            var value = filter.split(/=(.+)/)
            if (value.length > 1) {
              switch (value[0]) {
                case 'fullname':
                case 'gender':
                case 'app':
                case 'email':
                case 'status':
                case 'tags':
                case 'context':
                case 'membertype':
                case 'projectname':
                case 'projecttype':
                case 'memberstatus':
                case 'dpType':
                case 'phoneno':
                  vm.filter[value[0]] = value[1]
                  return { id: value[0], value: value[1] }
                  break
                case 'messagesent':
                  var messagesent = value[1].split('__')
                  vm.filter[value[0]] = {
                    value: messagesent[1],
                    symbol: messagesent[0] + '__',
                  }
                  return {
                    id: value[0],
                    value: {
                      value: messagesent[1],
                      symbol: messagesent[0] + '__',
                    },
                  }
                  break
                case 'locale':
                  var locales = value[1].split(',')
                  vm.filter.locale = []
                  vm.filter.locale = vm.localeOptions
                    .map((configLocal, clindex) => {
                      if (locales.includes(configLocal.value)) {
                        return configLocal
                      } else {
                        return null
                      }
                    })
                    .filter((el) => {
                      return el != null
                    })
                  return { id: 'locale', value: vm.filter.locale }
                  break
                case 'intent':
                  vm.filter.intent = value[1].split(',')
                  return { id: 'intent', value: value[1].split(',') }
                  break
                case 'timestamp_from':
                  vm.filter.activeDate.start = moment(value[1]).toDate()
                  return { id: 'activeDate_start', value: moment(value[1]).toDate() }
                  break
                case 'timestamp_to':
                  vm.filter.activeDate.end = moment(value[1]).toDate()
                  return { id: 'activeDate_end', value: moment(value[1]).toDate() }
                  break
                case 'registertimestamp_from':
                  vm.filter.registerDate.start = moment(value[1]).toDate()
                  return { id: 'registerDate_start', value: moment(value[1]).toDate() }
                  break
                case 'registertimestamp_to':
                  vm.filter.registerDate.end = moment(value[1]).toDate()
                  return { id: 'registerDate_end', value: moment(value[1]).toDate() }
                  break
              }
            }
          })

          if (f.length == 1 && (vm.filter['app'] == 'facebook' || vm.filter['app'] == 'line')) {
            vm.groupType = vm.filter['app']
          } else {
            vm.groupType = 'customize'
          }
        }

        vm.name = vm.broadcast.name
        vm.type = 'json'
        vm.quick_reply = vm.broadcast.m_quick_reply
        vm.sendtype = vm.broadcast.sendtype
        vm.pushtype = vm.broadcast.pushtype

        this.update_status = vm.broadcast.update_user_status
        this.update_tags = vm.broadcast.update_tags

        if (vm.broadcast.m_type == 'template') {
          vm.messages = [
            [
              {
                type: 'generic',
                data: JSON.parse(vm.broadcast.m_val),
                ratio: vm.broadcast.ratio == 'horizontal' ? 'horizontal' : 'square',
              },
            ],
          ]
        } else if (vm.broadcast.m_type == 'json') {
          vm.messages = JSON.parse(vm.broadcast.m_val)
        } else {
          var newGroup = []
          var group = vm.broadcast.m_val.split('||')
          $.each(group, function (index, messages) {
            var newMessage = []
            var group_messages = messages.split('#nl')
            $.each(group_messages, function (index, message) {
              var type = 'text'
              if (!isNaN(message)) {
                newMessage.push({
                  type: 'text',
                  text: message,
                })
              } else if (vm.isJsonParseable(message)) {
                var messageParsed = JSON.parse(message)
                newMessage.push({
                  text: messageParsed.text,
                  buttons: messageParsed.buttons,
                  type: 'button',
                })
              } else if (vm.isURL(message)) {
                newMessage.push({
                  type: 'image',
                  image_url: message,
                })
              } else {
                newMessage.push({
                  type: 'text',
                  text: message,
                })
              }
            })
            newGroup.push(newMessage)
          })
          vm.messages = newGroup
        }
      } else {
        vm.broadcast = undefined
      }
    },
    onSave: function (payload) {
      var vm = this
      vm.saveBroadcast(payload.data, function (status, id) {
        payload.onSave(status, id)
      })
    },
    saveBroadcast: function (data, callback) {
      api.updateBroadcast(data, function (error, response) {
        if (error) {
          console.error(error)
          callback(false, null)
          return
        }
        var id = null
        if (response.broadcastid) {
          id = response.broadcastid
        }
        callback(true, id)
      })
    },
    onBack: function () {
      var vm = this
      vm.$emit('onClose')
    },
  },
  watch: {
    value: function () {
      this.reset()
    },
  },
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/broadcast/Detail.vue